import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

const formatValue = (value, title) => {
  if (!value) {
    return '';
  }

  let units = '';
  if (title === 'Data') {
    units = 'MB';
  } else if (title === 'Voice') {
    units = 'Minutes';
  } else if (title === 'Text') {
    units = 'SMS';
  }

  if (value === 'unlimited') {
    return 'Unlimited';
  } else {
    return `${Number(value)} ${units}`;
  }
};

const QuickUsageInfo = ({ title, data }) => {
  return (
    <div>
      <h3 className={cn('h3', styles.title)}>{title}</h3>
      <ul className={styles.list}>
        <li className={styles.item}>
          <b>Used:</b> {formatValue(data?.used, title)}
        </li>
        <li className={styles.item}>
          <b>Remaining:</b> {formatValue(data?.remaining, title)}
        </li>
        <li className={styles.item}>
          <b>Total:</b> {formatValue(data?.total, title)}
        </li>
      </ul>
    </div>
  );
};

export default QuickUsageInfo;
